import { SaveIconDiskette } from "../../../../shared/icons/SaveIconDiskette";
import styles from "../styles.module.css";
import type { FC } from "react";
import type { IconButtonProps } from "@mui/material";
import { IconButton } from "@mui/material";
import { AppPopover } from "../../../AppPopover";
import { usePopover } from "../../../hooks/use-popover";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface Props extends IconButtonProps {
  name: string;
  onRefreshVersion: () => void;
  isDisabled: boolean;
}

export const SaveVersionAction: FC<Props> = ({
  name,
  onRefreshVersion,
  isDisabled,
  ...props
}) => {
  const {
    anchorPopoverEl,
    openPopover,
    handleOpenPopover,
    handleClosePopover,
  } = usePopover();
  const { t } = useTranslation();
  return (
    <>
      <IconButton
        className={classNames(styles["action-button"], {
          [styles["disabled"]]: name === undefined || isDisabled,
        })}
        onClick={handleOpenPopover}
        disabled={name === undefined || isDisabled}
        {...props}
      >
        <SaveIconDiskette />
      </IconButton>
      <AppPopover
        open={openPopover}
        anchorEl={anchorPopoverEl}
        onClose={handleClosePopover}
        onOk={() => {
          onRefreshVersion();
          handleClosePopover();
        }}
      >
        {t("versioning.update_popover")}
        <strong>{name}</strong>?
      </AppPopover>
    </>
  );
};
